export const collectorDefaults = {
  channels: [],
  fields: ["id", "date", "message", "editDate", "views", "forwards"],
  limit: 100,
  offset: 0,
  interval: 1,
  name: "",
};
